import AlarmFeedBell from 'features/alarms/components/alarm-feed-bell'
import { Button } from 'primereact/button'
import { Menu } from 'primereact/menu'
import { classNames } from 'primereact/utils'
import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppTopbarRef } from 'types'
import { useLayout } from '../context/layout-context'
import { useToast } from '../context/toast-context'
import { useIsMobile } from 'shared/hooks/use-is-mobile'

const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {
  const { layoutConfig, layoutState, onMenuToggle } = useLayout()
  const { showInfo } = useToast()
  const menubuttonRef = useRef(null)
  const topbarmenuRef = useRef(null)
  const topbarmenubuttonRef = useRef(null)
  const userMenuRef = useRef<Menu>(null)
  const isMobile = useIsMobile()
  const navigate = useNavigate()

  useImperativeHandle(ref, () => ({
    menubutton: menubuttonRef.current,
    topbarmenu: topbarmenuRef.current,
    topbarmenubutton: topbarmenubuttonRef.current,
  }))

  const userMenuItems = [
    {
      label: 'Meu Perfil',
      icon: 'pi pi-user',
      command: () => {
        showInfo('Perfil', 'Redirecionando para o perfil...')
      },
    },
    {
      label: 'Configurações',
      icon: 'pi pi-cog',
      command: () => {
        showInfo('Configurações', 'Abrindo configurações...')
      },
    },
    {
      separator: true,
    },
    {
      label: 'Suporte',
      icon: 'pi pi-question-circle',
      command: () => {
        showInfo('Suporte', 'Entrando em contato com suporte...')
      },
    },
    {
      separator: true,
    },
  ]

  const isDesktop = !isMobile
  const isStaticMode = layoutConfig.menuMode === 'static'
  const isSidebarActive =
    isDesktop && isStaticMode && !layoutState.staticMenuDesktopInactive

  return (
    <>
      <Menu
        model={userMenuItems}
        popup
        ref={userMenuRef}
      />
      <div
        className={classNames('enhanced-topbar', {
          'sidebar-visible': isSidebarActive,
          mobile: isMobile,
        })}
      >
        <div className='topbar-left'>
          <Button
            ref={menubuttonRef}
            icon='pi pi-bars'
            className='topbar-menu-button'
            onClick={onMenuToggle}
          />
        </div>

        <div className='topbar-center'>
          <div className='topbar-brand'>
            <img
              src='/favicon.png'
              alt=''
              className='topbar-brand-icon'
            />
            <span className='topbar-brand-text'>RT GUARD</span>
          </div>
        </div>

        <div className='topbar-right'>
          <div className='topbar-actions'>
            <AlarmFeedBell />
            {!isMobile && (
              <div className='action-item'>
                <Button
                  icon='pi pi-cog'
                  className='topbar-action-button'
                  tooltipOptions={{ position: 'bottom' }}
                  onClick={() => navigate('/settings')}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
})

AppTopbar.displayName = 'AppTopbar'

export default AppTopbar
